import { QueryDtoOf } from '@40seas/entities/common';
import { Billing } from './billing.entity';

export class BillingQueryDto extends QueryDtoOf(Billing) {}
